import { render, staticRenderFns } from "./PlateFooter.vue?vue&type=template&id=7fc27026&scoped=true&"
import script from "./PlateFooter.vue?vue&type=script&lang=js&"
export * from "./PlateFooter.vue?vue&type=script&lang=js&"
import style0 from "./PlateFooter.vue?vue&type=style&index=0&id=7fc27026&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc27026",
  null
  
)

export default component.exports